import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { OverlayTrigger, Overlay, Popover, Dropdown } from 'react-bootstrap'
import Upload from '@vmockinc/dashboard/Dashboard/containers/Upload'
import UploadPdf from '../components/LoginScreens/UploadPdf'
import ChangeFunction from '../components/LoginScreens/ChangeFunction'
import IntegrateToLinkedIn from '../components/LoginScreens/IntegrateToLinkedIn'
import { notification } from '../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { sectionUnderscoreFeedbackMapping } from '../components/Constants/UniversalMapping'
import {
  updateResumeState,
  updatePdfState,
  updateFunctionState,
  uploadResumeInit,
  uploadResumeDone,
  updateResumeFeedback,
  getSuggestedFunctions,
  fetchResumeFunc,
  fetchCFFunc,
} from '../actions/Login'
import { generatePdf } from '../actions/GeneratePdf'
import { updateEditedDataState, showLogModal } from '../actions/Edit'
import {
  checkForRendering,
  showFeedbackModal,
} from '../actions/CustomerFeedback'
import { downloadImage } from '../actions/ImageUpload'

import CustomerFeedback from '../components/CustomerFeedback/CustomerFeedback'
import constants from '../config/constants'
import _ from 'underscore'
import { startTour } from '../tour/Action'
import { fetchUploadCount } from '@vmockinc/dashboard/Aspire/actions'
import { Modal, ModalBody } from '@vmockinc/dashboard/Common/commonComps/Modal'
import { aspireIntroToggle } from '@vmockinc/dashboard/Aspire/actions'
import FocusLock from 'react-focus-lock'
import { Link, NavLink } from 'react-router-dom'
import PageTracking from '@vmockinc/dashboard/Common/commonComps/PageTracking'
import TimeAgo from 'react-timeago'
import { selectSection } from '../actions/DetailedFeedback'
import { redirectSelect } from '../actions/AspireFeedback'
import { showEditModal } from '../actions/Edit'
import LogScreen from '../components/LogScreen'
import { timeAgoFormatter } from '@vmockinc/dashboard/src/languages/index.js'
import ProductIntroVideo from '@vmockinc/dashboard/Dashboard/containers/ProductIntroVideo'

const timeOutMilliseconds = 2000
let isCalled = false

class AppBar extends Component {
  constructor() {
    super()
    this.state = {
      showTargetFuncModal: false,
      show: true,
      lastFocusedElement: null,
      showDirectIntegrationModal: false,
      integratePopOver: true,
      showLogModal: false,
    }
    this.tabIndex = 10
    this.targetFunctionBackToFrontEndMapping = {}
    this.newResumeFetchId = 0 // Don't need re-rendering on change of this value. Hence not in state
    this.newPdfFetchId = 0 // Don't need re-rendering on change of this value. Hence not in state
    this.newFunctionFetchId = 0 // Don't need re-rendering on change of this.
    this.newUploadedAtEdit = 0 // Don't need re-rendering on change of this.
    this.displayPdfModal = this.displayPdfModal.bind(this)
    this.displayTargetFuncModal = this.displayTargetFuncModal.bind(this)
    this.displayDirectIntegrationModal =
      this.displayDirectIntegrationModal.bind(this)
    this.hidePdfModal = this.hidePdfModal.bind(this)
    this.hideTargetFuncModal = this.hideTargetFuncModal.bind(this)
    this.hideDirectIntegrationModal = this.hideDirectIntegrationModal.bind(this)
    this.handleTourClick = this.handleTourClick.bind(this)
    this.aspireIntroVideo = this.aspireIntroVideo.bind(this)
    this.downloadPdf = this.downloadPdf.bind(this)
    this.downloadImage = this.downloadImage.bind(this)
    this.giveFeedback = this.giveFeedback.bind(this)
    this.hashLinkScroll = this.hashLinkScroll.bind(this)
    this.handleOnMouseOverAddResume = this.handleOnMouseOverAddResume.bind(this)
    this.handleOnMouseOutAddResume = this.handleOnMouseOutAddResume.bind(this)
    this.showLogModal = this.showLogModal.bind(this)
    this.hideLogModal = this.hideLogModal.bind(this)
    this.getTextFromFeedback = this.getTextFromFeedback.bind(this)
    this.handleThreeDotsClickTracking =
      this.handleThreeDotsClickTracking.bind(this)
    this.giveFeedbackDebounce = _.debounce(this.giveFeedback, 5000, true)
    this.downloadPdfDebounce = _.debounce(this.downloadPdf, 5000, true)
    this.downloadImageDebounce = _.debounce(this.downloadImage, 5000, true)
    this.debounceTime = 5000
    this.sendTrackingDataDebounce = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceResume = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebouncePdf = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceTf = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceTour = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceSummaryBtn = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceDetailedBtn = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceDownloadPdf = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceGiveFeedbackBtn = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceThreeDotsBtn = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
  }

  UNSAFE_componentWillMount() {
    const { functions, fetchUploadCount } = this.props
    this.targetFunctionBackToFrontEndMapping = functions['mapping']
    fetchUploadCount()
  }

  componentDidMount() {
    const {
      status,
      allSmallResume,
      fetchResumeFunc,
      fetchCFFunc,
      getSuggestedFunctions,
      intl,
    } = this.props
    if (status == 'wrong_resume') {
      notification(
        intl.formatMessage({
          id: 'aspire.appBar.wrongResume',
          defaultMessage: 'Wrong {resumeType} file uploaded !',
        }, { resumeType: allSmallResume }),
        'error',
        timeOutMilliseconds
      )
    } else if (status == 'wrong_pdf') {
      notification(
        intl.formatMessage({
          id: 'aspire.appBar.wrongPdf',
          defaultMessage: 'Wrong pdf file uploaded !',
        }),
        'error',
        timeOutMilliseconds
      )
    } else if (status == 'invalid_pdf') {
      notification(
        intl.formatMessage({
          id: 'aspire.appBar.invalidPdf',
          defaultMessage: 'Invalid pdf file uploaded !',
        }),
        'error',
        timeOutMilliseconds
      )
    } else if (status == 'unsupported_language') {
      notification(
        intl.formatMessage({
          id: 'aspire.appBar.unsupportedLanguage',
          defaultMessage: "Currently, we don't support this language in LinkedIn pdf. We have notified our tech team and will reach back to you soon.",
        }),
        'error',
        4000
      )
    }

    setTimeout(() => {
      this.setState({ show: false, integratePopOver: false })
    }, 3000)

    getSuggestedFunctions()
    fetchResumeFunc()
    fetchCFFunc()
  }
  componentDidUpdate() {
    const {
      uploaded_resume,
      uploaded_pdf,
      uploaded_edited_data,
      changed_function,
      visited_sections,
      customerFeedback,
    } = this.props
    let detailed_personal_info = 0
    let detailed_profile_picture = 0
    let detailed_headline = 0
    let detailed_summary = 0
    let detailed_experience = 0
    let detailed_education = 0

    if (visited_sections.hasOwnProperty('detailed_personal_info')) {
      detailed_personal_info = visited_sections['detailed_personal_info']
    }

    if (visited_sections.hasOwnProperty('detailed_profile_picture')) {
      detailed_profile_picture = visited_sections['detailed_profile_picture']
    }

    if (visited_sections.hasOwnProperty('detailed_headline')) {
      detailed_headline = visited_sections['detailed_headline']
    }

    if (visited_sections.hasOwnProperty('detailed_summary')) {
      detailed_summary = visited_sections['detailed_summary']
    }

    if (visited_sections.hasOwnProperty('detailed_experience')) {
      detailed_experience = visited_sections['detailed_experience']
    }

    if (visited_sections.hasOwnProperty('detailed_education')) {
      detailed_education = visited_sections['detailed_education']
    }

    if (
      detailed_personal_info &&
      detailed_profile_picture &&
      detailed_headline &&
      detailed_summary &&
      detailed_experience &&
      detailed_education &&
      !isCalled
    ) {
      isCalled = true
      let interval = constants.interval
      interval = interval * 60 * 1000
      const { checkForRendering } = this.props
      setTimeout(function () {
        checkForRendering()
      }, interval)
    }
    if (uploaded_resume == true) {
      const { fetchId, idResume, feedback_fetching, fetchResume } = this.props
      if (idResume == fetchId || idResume == this.newResumeFetchId) {
        if (feedback_fetching == false) {
          const { updateResumeState } = this.props
          updateResumeState({
            updateKeys: [['uploading_resume'], ['uploaded_resume']],
            data: { uploading_resume: false, uploaded_resume: false },
          })
          this.newResumeFetchId = 0
        }
      } else {
        this.newResumeFetchId = idResume
        fetchResume(idResume)
      }
    }

    if (uploaded_pdf == true) {
      const { fetchId, idPdf, feedback_fetching, fetchPdf } = this.props
      if (idPdf == fetchId || idPdf == this.newPdfFetchId) {
        if (feedback_fetching == false) {
          const { updatePdfState } = this.props
          updatePdfState({
            updateKeys: [['uploading_pdf'], ['uploaded_pdf']],
            data: { uploading_pdf: false, uploaded_pdf: false },
          })
          this.newPdfFetchId = 0
        }
      } else {
        this.newPdfFetchId = idPdf
        fetchPdf(idPdf)
      }
    }

    if (changed_function == true) {
      const { fetchId, idFunction, feedback_fetching, fetchChangedFunction } =
        this.props
      if (idFunction == fetchId || idFunction == this.newFunctionFetchId) {
        if (feedback_fetching == false) {
          const { updateFunctionState } = this.props
          updateFunctionState({
            updateKeys: [['changing_function'], ['changed_function']],
            data: { changing_function: false, changed_function: false },
          })
        }
      } else {
        this.newFunctionFetchId = idFunction
        fetchChangedFunction(idFunction)
      }
    }

    if (uploaded_edited_data == true) {
      const { idEdit, uploadedAtEdit, feedback_fetching, fetchEditedData } =
        this.props
      if (uploadedAtEdit == this.newUploadedAtEdit) {
        if (feedback_fetching == false) {
          const { updateEditedDataState } = this.props
          updateEditedDataState({
            updateKeys: [['uploading_edited_data'], ['uploaded_edited_data']],
            data: { uploading_edited_data: false, uploaded_edited_data: false },
          })
        }
      } else {
        this.newUploadedAtEdit = uploadedAtEdit
        fetchEditedData(idEdit)
      }
    }
  }

  handleThreeDotsClickTracking(buttonDisabled) {
    if (!buttonDisabled) {
      this.sendTrackingDataDebounceThreeDotsBtn(
        'event',
        'aspire_appbar',
        'click',
        'three_dots_btn'
      )
    } else {
      this.sendTrackingDataDebounceThreeDotsBtn(
        'event',
        'aspire_appbar',
        'click',
        'disabled_three_dots_btn'
      )
    }
  }

  handleTourClick() {
    this.sendTrackingDataDebounceTour(
      'event',
      'aspire_appbar',
      'click',
      'tour_btn'
    )
    this.props.startTour()
  }

  aspireIntroVideo() {
    const { userCustomizations, aspireIntroToggle } = this.props
    sendTrackingData('event', 'aspire_appbar', 'click', 'aspire_intro_video')
    if (userCustomizations.show_aspire_intro_video) {
      aspireIntroToggle()
    }
  }

  displayPdfModal() {
    this.sendTrackingDataDebouncePdf(
      'event',
      'aspire_appbar',
      'click',
      'pdf_modal_open'
    )
    const { updatePdfState } = this.props

    updatePdfState({
      updateKeys: [['showPdfModal']],
      data: { showPdfModal: true },
    })
  }

  hidePdfModal(type = 'outside') {
    if (type == 'close_btn') {
      sendTrackingData('event', 'aspire_appbar', 'click', 'pdf_modal_close_btn')
    } else {
      sendTrackingData('event', 'aspire_appbar', 'click', 'pdf_modal_close')
    }
    const { updatePdfState } = this.props
    updatePdfState({
      updateKeys: [['showPdfModal']],
      data: { showPdfModal: false },
    })
  }

  displayTargetFuncModal() {
    const { processingStatus } = this.props
    if (!(processingStatus == 'processing' || _.isNull(processingStatus))) {
      this.sendTrackingDataDebounceTf(
        'event',
        'aspire_appbar',
        'click',
        'target_functions_modal_open'
      )
      this.setState({ lastFocusedElement: document.activeElement })

      this.setState({ showTargetFuncModal: true })
    }
  }

  hideTargetFuncModal(type = 'outside') {
    if (type == 'close_btn') {
      sendTrackingData(
        'event',
        'aspire_appbar',
        'click',
        'target_functions_modal_close_btn'
      )
    } else {
      sendTrackingData(
        'event',
        'aspire_appbar',
        'click',
        'target_functions_modal_close'
      )
    }
    this.setState({ showTargetFuncModal: false })
    if (this.state.lastFocusedElement) {
      setTimeout(() => {
        this.state.lastFocusedElement.focus()
      }, 1)
    }
  }

  displayDirectIntegrationModal() {
    this.setState({ lastFocusedElement: document.activeElement })
    this.setState({
      showDirectIntegrationModal: true,
    })
    if (this.props.sectionToSuggestCopy.firstUpdate) {
      this.setState({
        integratePopOver: false,
      })
    }
    this.sendTrackingDataDebounce(
      'event',
      'aspire_appbar',
      'click',
      'integration_modal_open'
    )
  }

  hideDirectIntegrationModal() {
    this.setState({
      showDirectIntegrationModal: false,
    })
    if (this.state.lastFocusedElement) {
      setTimeout(() => {
        this.state.lastFocusedElement.focus()
      }, 1)
    }
    this.sendTrackingDataDebounce(
      'event',
      'aspire_integration_modal',
      'click',
      'integration_modal_close'
    )
  }

  downloadPdf() {
    this.sendTrackingDataDebounceDownloadPdf(
      'event',
      'aspire_appbar',
      'click',
      'download_pdf_btn'
    )

    if (!_.isEmpty(this.props.loaderInput)) {
      this.sendTrackingDataDebounce(
        'process',
        'aspire_appbar',
        'notify_error',
        'cannot_download_pdf_until_processing_complete'
      )
      notification(
        'Cannot download PDF until current processing is complete.',
        'error',
        timeOutMilliseconds
      )
      return
    }

    const { generatePdf, intl } = this.props
    let data = $.extend(true, {}, this.props.ui.sectionWiseTextStatic)
    data['personal_information'][0]['info'] =
      this.props.ui.sectionWiseTextPdf.personal_information
    generatePdf(data, intl)
  }

  downloadImage(url) {
    this.sendTrackingDataDebounceDownloadPdf(
      'event',
      'aspire_integration_modal',
      'click',
      'download_image_btn'
    )

    const { downloadImage, intl } = this.props
    downloadImage(url, intl)
  }

  giveFeedback() {
    this.props.showFeedbackModal()
    this.sendTrackingDataDebounceGiveFeedbackBtn(
      'event',
      'aspire_appbar',
      'click',
      'give_feedback_btn'
    )
  }

  handleOnMouseOverAddResume() {
    this.setState({ show: true })
  }

  handleOnMouseOutAddResume() {
    this.setState({ show: false })
  }

  fetchUpdatedFeedback() {
    const { updateResumeFeedback } = this.props
    updateResumeFeedback(this.props.fetchId)
  }

  renderAspireIntroVideo() {
    const { userCustomizations, aspireIntroToggle } = this.props
    if (userCustomizations.show_aspire_intro_video) {
      return <ProductIntroVideo productName={"aspire"} onToggle={aspireIntroToggle} />
    } else return null
  }

  hideLogModal() {
    const { showLogModal } = this.props
    showLogModal(false)
    this.setState({ showLogModal: false })
  }

  showLogModal() {
    const { showLogModal } = this.props
    showLogModal(true)
    this.setState({ showLogModal: true })
  }

  getTextForHeadline(textArray) {
    for (let divId in textArray) {
      if (textArray[divId].hasOwnProperty('text')) {
        return textArray[divId]['text']
      }
    }
  }

  getTextFromFeedback() {
    const { feedbackData, sectionToSuggestCopy } = this.props
    var output = []
    _.map(sectionToSuggestCopy.section_array, (value, key) => {
      if (value['section_name'] == 'Profile Picture') {
        output.push({
          title: 'Profile Picture',
          content:
            feedbackData['profile_picture_feedback']['profile_picture_url'],
          scoreChange: value['score_improve'],
          id: key,
        })
      } else if (value['section_name'] == 'LinkedIn URL') {
        output.push({
          title: value['section_name'],
          content:
            feedbackData['personal_information_feedback']['url_score_class'][
              'url'
            ],
          scoreChange: value['score_improve'],
          id: key,
        })
      } else if (value['section_name'] == 'Profile Name') {
        output.push({
          title: value['section_name'],
          content:
            feedbackData['personal_information_feedback'][
              'profile_name_score_class'
            ]['name'],
          scoreChange: value['score_improve'],
          id: key,
        })
      } else {
        let sectionKey = sectionUnderscoreFeedbackMapping[value['section_name']]
        if (
          _.isUndefined(feedbackData[sectionKey]) ||
          _.isUndefined(feedbackData[sectionKey]['text_array']) ||
          _.isEmpty(feedbackData[sectionKey]['text_array'])
        ) {
        } else {
          if (sectionKey == 'headline_feedback') {
            output.push({
              title: 'Headline',
              content: this.getTextForHeadline(
                feedbackData[sectionKey]['text_array']
              ),
              scoreChange: value['score_improve'],
              id: key,
            })
          } else if (sectionKey == 'summary_feedback') {
            output.push({
              title: 'Summary',
              content: this.getTextForContent(
                feedbackData[sectionKey]['text_array']
              ),
              scoreChange: value['score_improve'],
              id: key,
            })
          } else {
            output.push({
              title: this.getEdExTitle(
                feedbackData[sectionKey]['categories_present'][
                  value['sub_section_id']
                ],
                value['section_name']
              ),
              content: this.getTextForContent(
                feedbackData[sectionKey]['text_array'][value['sub_section_id']]
              ),
              scoreChange: value['score_improve'],
              id: key,
            })
          }
        }
      }
    })

    var result = output.filter(function (value) {
      return !_.isEmpty(value['content'])
    })

    return result
  }

  getTextForContent(textArray) {
    let content = []
    let currentLineId = null
    let prevLineId = null
    for (let divId in textArray) {
      if (
        textArray[divId]['is_title'] ||
        textArray[divId]['is_sub_title'] ||
        textArray[divId]['is_time_duration']
      ) {
        continue
      }
      if (_.isNull(currentLineId)) {
        currentLineId = textArray[divId]['new_line_id']
      }
      if (currentLineId !== textArray[divId]['new_line_id']) {
        content.push(<br />)
        prevLineId = currentLineId
        currentLineId = textArray[divId]['new_line_id']
      }
      if (textArray[divId]['has_real_bullet_symbol']) {
        if (currentLineId !== prevLineId) {
          let bulletSymbol = textArray[divId].hasOwnProperty(
            'bullet_numeric_value'
          )
            ? textArray[divId]['bullet_numeric_value']
            : !_.isEmpty(textArray[divId]['original_bullet_full_symbol'])
            ? textArray[divId]['original_bullet_full_symbol'].trim()
            : String.fromCharCode(textArray[divId]['bullet_ascii_value'])
          prevLineId = currentLineId
          content.push(`${bulletSymbol} `)
        }
      }
      content.push(textArray[divId]['text'])
    }
    if (content.indexOf('Activities and Societies:') != -1) {
      content[content.indexOf('Activities and Societies: ')] = ''
    }

    return content
  }

  getEdExTitle(categories, sectionName) {
    let sectionTitle = sectionName
    let toCheckFor = 'company_name'
    if (sectionName === 'Education') {
      toCheckFor = 'schools'
    }
    for (let divId in categories) {
      if (categories[divId].hasOwnProperty(toCheckFor)) {
        let place = categories[divId][toCheckFor][0]['keyword']
        sectionTitle += ` at ${place}`
        break
      }
    }

    return sectionTitle
  }

  updateCount() {
    const { sectionToSuggestCopy } = this.props
    let sectionTiles = []
    let textArray = this.getTextFromFeedback()
    let count = 0
    if (_.isEmpty(sectionToSuggestCopy.section_array) || _.isEmpty(textArray)) {
      count = 0
    } else {
      _.map(textArray, (value, key) => {
        if (value['title'] == 'Profile Picture') {
          let imageUrl = value['content']
          count++
        } else {
          count++
        }
      })
    }

    return count
  }

  hashLinkScroll() {
    const { hash } = window.location
    if (hash !== '') {
      setTimeout(() => {
        let id = hash.replace('#', '')
        if (id == 'profile_picture' || hash === '#overall') {
          id = 'profile_picture_linkedin'
        }
        const element = document.getElementById(id)
        if (element) {
          if (id == 'profile_picture' || hash === '#overall') {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          } else {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      }, 0)
    }
  }
  render() {
    const {
      fetchId,
      targetJobFunctions,
      hasResume,
      status,
      processingStatus,
      allSmallResume,
      normalResume,
      sectionToSuggestCopy,
      feedbackData,
      linkedInUrl,
      isEditOpen,
      page,
      allResumes,
      currentResumeId,
      userCustomizations,
      user,
      aspireUploadCount,
      lastSaved,
      selectSection,
      redirectSelect,
      showEditModal,
      isEditModal,
      intl,
      pdfLanguage,
      functions,
    } = this.props
    let tabIndex = this.tabIndex
    let currentResume = _.findWhere(allResumes, { id: currentResumeId })

    const { community, benchmark, isResumeCalledCv } = user
    let resumeFullFileName =
      community === 'nyustern'
        ? !hasResume
          ? intl.formatMessage({
              id: 'aspire.appBar.addResumeTooltip',
              defaultMessage: 'Add your {resumeType} to identify the skill gaps and ensure consistency between your resume and LinkedIn profile',
            }, { resumeType: 'resume' })
          : intl.formatMessage({
              id: 'aspire.appBar.changeResumeTooltip',
              defaultMessage: 'Change your {resumeType} to identify the updated skill gaps and ensure consistency between your resume and LinkedIn profile',
            }, { resumeType: 'resume' })
        : !hasResume
        ? intl.formatMessage({
            id: 'aspire.appBar.addResumeTooltip',
            defaultMessage: 'Add your {resumeType} to identify the skill gaps and ensure consistency between your resume and LinkedIn profile',
          }, { resumeType: allSmallResume })
        : intl.formatMessage({
            id: 'aspire.appBar.changeResumeTooltip',
            defaultMessage: 'Change your {resumeType} to identify the updated skill gaps and ensure consistency between your resume and LinkedIn profile',
          }, { resumeType: allSmallResume })
    let addResumeText = hasResume
      ? intl.formatMessage({
          id: 'aspire.appBar.changeResumeBtn',
          defaultMessage: 'Change {resumeName}',
        }, { resumeName: normalResume })
      : intl.formatMessage({
          id: 'aspire.appBar.addResumeBtn',
          defaultMessage: 'Add {resumeName}',
        }, { resumeName: normalResume })

    let tooltipClassName = 'tooltipped tooltipped-s as-tooltip'
    let uploadBtnClass = `appbar-add-resume-btn js-detailed-add-resume ${
      this.state.show && !hasResume && 'showTooltip'
    } ${community === 'nyustern' && 'long-tooltip'}`

    let lastSavedBlock = null

    if (!_.isEmpty(lastSaved)) {
      let now = new Date()
      let offset = now.getTimezoneOffset()
      let time = Date.parse(new Date(lastSaved)) - offset * 60000
      let timeago = Date.now() - time
      let popOverLastSaved = (
        <Popover id="popover-last-save" className="as-popover">
          {
            intl.formatMessage({
              id: 'aspire.appBar.popoverLastSaved',
              defaultMessage: 'Check previous edits',
            })
          }
        </Popover>
      )
      lastSavedBlock = (
        <>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            rootClose
            placement="bottom"
            overlay={popOverLastSaved}>
            <div
              className="last-saved-btn"
              onClick={() => this.showLogModal()}
              role="menuitem"
              tabIndex="0">
              <div
                className="last-saved-div"
                aria-label={intl.formatMessage({
                  id: 'aspire.appBar.lastSavedAria',
                  defaultMessage: 'Click here to see previous edit logs',
                })}>
                <img
                  src={`${process.env.APP_BASE_URL}dist/images/ic_data_save.svg`}
                  alt=""
                  className="last-saved-img"
                  height="24px"
                  width="24px"
                />
                <div className="last-saved-text">
                  <FormattedMessage
                    id="aspire.appBar.lastSavedText"
                    defaultMessage="Data Saved"
                  />
                </div>
                <div className="last-saved-time">
                  {timeago < 60000 ? (
                    <FormattedMessage
                      id="aspire.appBar.lastSavedSecondsAgo"
                      defaultMessage="seconds ago"
                    />
                  ) : (
                    <TimeAgo
                      date={time}
                      formatter={timeAgoFormatter(pdfLanguage)}
                    />
                  )}
                </div>
              </div>
            </div>
          </OverlayTrigger>
          <div className="last-saved-btn-divider" role="menuitem"></div>
        </>
      )
    }
    let popOverResumeName
    if (currentResume !== undefined && currentResume.filename) {
      popOverResumeName = (
        <Popover id="popover-resume-name" className="as-popover">
          {currentResume.filename}
        </Popover>
      )
    }

    let popoverResumeBtn = (
      <Popover id="popover-resume-name" className="as-popover">
        {resumeFullFileName}
      </Popover>
    )

    let addResumeBlock = (
      <div className="add-resume-btn-margin" role="menuitem">
        <>
          {hasResume &&
          currentResume !== undefined &&
          currentResume.filename ? (
            <>
              <OverlayTrigger
                trigger={['hover', 'focus']}
                rootClose
                placement="bottom"
                overlay={popOverResumeName}>
                <div className="resume-btn-resume-name">
                  <FormattedMessage
                    id="aspire.appBar.resumeLabel"
                    defaultMessage="{resumeType} : "
                    values={{
                      resumeType: isResumeCalledCv ? 'CV ' : 'Resume ',
                    }}
                  />
                  <span style={{ color: '#444444', fontWeight: '500' }}>
                    {currentResume.filename}
                  </span>
                </div>
              </OverlayTrigger>
              <div className="divider" />
            </>
          ) : null}
          {userCustomizations.aspire_user_upload_limit !== null && (
            <Upload
              product="aspire"
              tooltipText={resumeFullFileName}
              tooltipClassName={tooltipClassName}
              className={uploadBtnClass}
              showUploadModal={true}
              btnText={addResumeText}
              tabIndex={tabIndex}
              disabled={
                processingStatus === 'processing' || _.isNull(processingStatus)
              }
              addLeftCount={true}
              successfulUploadAction={this.fetchUpdatedFeedback.bind(this)}
              initAction={this.props.uploadResumeInit}
              productLanguage={pdfLanguage}
            />
          )}
        </>
      </div>
    )

    let seeTargetFunctions = []
    let displayNames = functions['display_names']
    let noOfTargetFunctions = null
    let targetFunctionsModalButton = null
    if (processingStatus == 'processing' || _.isNull(processingStatus)) {
      noOfTargetFunctions = targetJobFunctions.length + ' ' + intl.formatMessage({
        id: 'aspire.appbar.targetFunctions',
        defaultMessage: 'Target Function(s)',
      })
      seeTargetFunctions.push(
        targetJobFunctions.map((value, key) => (
          <li>
            {
              displayNames?.[this.targetFunctionBackToFrontEndMapping[value]]
                ?? this.targetFunctionBackToFrontEndMapping[value]
            }
          </li>
        ))
      )
      targetFunctionsModalButton = (
        <a
          id="target_functions_modal_btn"
          role="button"
          className="appbar-btn-tf cursor-not-allowed js-detailed-target-functions"
          tabIndex={tabIndex}
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.targetFunctionsAriaProcessing',
            defaultMessage: 'Your profile is being processed, please wait, number of target functions - {noOfTargetFunctions} ',
          }, { noOfTargetFunctions })}
          href="javascript:void(0);">
          {' '}
          <img
            src={`${process.env.APP_BASE_URL}dist/images/target-icon.svg`}
            alt=""
            className="tf-modal-btn-img"
            height="18px"
          />
          {noOfTargetFunctions}{' '}
        </a>
      )
    } else {
      noOfTargetFunctions = targetJobFunctions.length + ' ' + intl.formatMessage({
        id: 'aspire.appbar.targetFunctions',
        defaultMessage: 'Target Function(s)',
      })
      seeTargetFunctions.push(
        targetJobFunctions.map((value, key) => (
          <li>
            {
              displayNames?.[this.targetFunctionBackToFrontEndMapping[value]]
                ?? this.targetFunctionBackToFrontEndMapping[value]
            }</li>
        ))
      )
      targetFunctionsModalButton = (
        <a
          role="button"
          className="appbar-btn-tf js-detailed-target-functions"
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#select-target-function"
          tabIndex={tabIndex}
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.targetFunctionsAria',
            defaultMessage: '{noOfTargetFunctions}, Click to change target functions, Profile will be processed automatically after you update target functions',
          }, { noOfTargetFunctions })}
          onClick={() => this.displayTargetFuncModal()}>
          {' '}
          <img
            src={`${process.env.APP_BASE_URL}dist/images/target-icon.svg`}
            alt=""
            className="tf-modal-btn-img"
            height="18px"
          />{' '}
          {noOfTargetFunctions}{' '}
        </a>
      )
    }
    
    let popOverTargetFunctions = (
      <Popover id="popover-target-functions" className="as-popover">
        <div className="popover-heading">
          {
            intl.formatMessage({
              id: 'aspire.appBar.currentTargetFunctions',
              defaultMessage: 'Current Target Function(s)',
            })
          }
        </div>
        <ul className="popover-list">{seeTargetFunctions}</ul>
      </Popover>
    )
    let disabledTourButton =
      processingStatus == 'processing' || _.isNull(processingStatus)
    let threeDotsBtn = (
      <Dropdown
        disabled={disabledTourButton}
        onClick={() => this.handleThreeDotsClickTracking(disabledTourButton)}
        id="three-dots-dropdown"
        className="three-dots-dropdown three-dots-dropdown-app-bar"
        role="menuitem">
        <Dropdown.Toggle
          tabIndex={tabIndex}
          noCaret
          className="three-dots-toggle-btn text-btn">
          <img
            src={`${process.env.APP_BASE_URL}dist/images/appbar-three-dots.svg`}
            alt={intl.formatMessage({
              id: 'aspire.appBar.menuBtnAlt',
              defaultMessage: 'menu btn',
            })}
            width="25px"
            height="25px"
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="three-dots-menu">
          <Dropdown.Item
            className="three-dots-menu-item"
            onClick={this.downloadPdfDebounce}
            eventKey="1">
            <FormattedMessage
              id="aspire.appBar.downloadPdf"
              defaultMessage="Download PDF"
            />
          </Dropdown.Item>
          {!userCustomizations.is_help_section_enabled ? (
            <>
              <Dropdown.Item
                className="three-dots-menu-item"
                onClick={this.giveFeedbackDebounce}
                eventKey="2">
                <FormattedMessage
                  id="aspire.appBar.giveFeedback"
                  defaultMessage="Give Feedback"
                />
              </Dropdown.Item>
              <Dropdown.Item
                className="three-dots-menu-item"
                onClick={this.handleTourClick}
                eventKey="3">
                <FormattedMessage
                  id="aspire.appBar.tour"
                  defaultMessage="Tour"
                />
              </Dropdown.Item>
              {userCustomizations.show_aspire_intro_video ? (
                <Dropdown.Item
                  className="three-dots-menu-item"
                  onClick={this.aspireIntroVideo}
                  eventKey="4">
                  <FormattedMessage
                    id="aspire.appBar.playQuickGuide"
                    defaultMessage="Play Quick Guide"
                  />
                </Dropdown.Item>
              ) : null}
            </>
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    )

    let updateCount = this.updateCount()

    if (page === 'summary') {
      threeDotsBtn = null
    }
    let popOverIntegrateToLinkedIn = (
      <Popover id="popover-contained-integration">
        {
          intl.formatMessage({
            id: 'aspire.appBar.popoverIntegrateToLinkedin',
            defaultMessage: 'Click to copy changes and update your LinkedIn profile',
          })
        }
      </Popover>
    )
    let linkedinIntegrationButtonText = intl.formatMessage({
      id: 'aspire.appBar.updateLinkedinBtn',
      defaultMessage: 'Update LinkedIn',
    })
    let updateCountAria = updateCount > 0 ? updateCount : ''
    let linkedinIntegrationButtonAria = intl.formatMessage({
      id: 'aspire.appBar.updateLinkedinAria',
      defaultMessage: 'Click to copy changes and update your linkedin profile, Update LinkedIn {updateCountAria}',
    }, { updateCountAria })

  
    let disabledlinkedinIntegrationButtonAria = 
      `${linkedinIntegrationButtonText}${updateCount > 0 ? ' ' + updateCount : ''} ` +
      intl.formatMessage({
        id: 'aspire.appBar.updateLinkedinAriaDisabled',
        defaultMessage: 'Click to copy changes and update your linkedin profile, disabled Update LinkedIn ',
      })

    let linkedinIntegrationButton = (
      <button
        id="integrate-button"
        className="btn btn-primary integrate-to-linkedin-appbar-btn"
        ref={(button) => {
          this.integrateButton = button
        }}
        onClick={this.displayDirectIntegrationModal}
        tabIndex={tabIndex}
        aria-label={linkedinIntegrationButtonAria}>
        {linkedinIntegrationButtonText}
        {updateCount > 0 && (
          <div className="integrate-to-linkedin-count">{updateCount}</div>
        )}
      </button>
    )

    if (processingStatus == 'processing' || _.isNull(processingStatus)) {
      linkedinIntegrationButton = (
        <button
          id="integrate-button"
          className="btn btn-primary integrate-to-linkedin-appbar-btn cursor-not-allowed"
          ref={(button) => {
            this.integrateButton = button
          }}
          tabIndex={tabIndex}
          aria-label={disabledlinkedinIntegrationButtonAria}
          disabled>
          {linkedinIntegrationButtonText}
          {updateCount > 0 && (
            <div className="integrate-to-linkedin-count">{updateCount}</div>
          )}
        </button>
      )
    }
    let linkedinIntegrationButtonWithOverlay = (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="bottom"
        rootClose
        overlay={popOverIntegrateToLinkedIn}>
        {linkedinIntegrationButton}
      </OverlayTrigger>
    )
    if (
      sectionToSuggestCopy.firstUpdate &&
      this.state.integratePopOver &&
      !isEditOpen
    ) {
      linkedinIntegrationButtonWithOverlay = []
      linkedinIntegrationButtonWithOverlay.push([
        linkedinIntegrationButton,
        <Overlay
          show={true}
          target={() => ReactDOM.findDOMNode(this.integrateButton)}
          placement="bottom"
          containerPadding={20}>
          {popOverIntegrateToLinkedIn}
        </Overlay>,
      ])
    }

    let aspireTracker = (page) => <AspireTracker id={fetchId} page={page} />

    let initialJobFunctions = [].concat(targetJobFunctions)
    return (
      <div role="main" aria-label="aspire feedback" id="start-of-content">
        <div className="aspire-nav outer-border navbar-app fixed-top">
          <div className="aspire-nav-left">
            <div className="navbar-nav me-auto">
              <Link
                to={`${process.env.APP_BASE_URL}${fetchId}/feedback/detailed`}
                tabIndex={tabIndex}
                className="modified-anchor navbar-app__nav-link"
                data-key="detailed"
                role="button"
                aria-label={intl.formatMessage({
                  id: 'aspire.appBar.detailedFeedback',
                  defaultMessage: 'Detailed Feedback',
                })}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  if (isEditModal) {
                    showEditModal(false, '')
                  }
                  selectSection('Overall')
                  redirectSelect(fetchId, 'detailed', 'Overall')
                  this.hashLinkScroll()
                  this.sendTrackingDataDebounceDetailedBtn(
                    'event',
                    'aspire_appbar',
                    'click',
                    'detailed_feedback_btn'
                  )
                }}>
                <FormattedMessage
                  id="aspire.appBar.detailedFeedback"
                  defaultMessage="Detailed Feedback"
                />
              </Link>{' '}
            </div>
          </div>
          <div className="aspire-nav-right">
            <div className="text-end">
              <div
                className="nav-bar-right"
                role="menubar">
                {lastSavedBlock}
                {addResumeBlock}
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  rootClose
                  placement="bottom"
                  overlay={popOverTargetFunctions}>
                  <div
                    key="numberOfFunctions"
                    className="tf-btn tf-blue-txt cursor-default"
                    role="menuitem">
                    {targetFunctionsModalButton}
                  </div>
                </OverlayTrigger>
                <div className="integrate-btn" role="menuitem">
                  {linkedinIntegrationButtonWithOverlay}
                </div>
                {threeDotsBtn}
              </div>
            </div>
          </div>
        </div>
        <div
          role="dialog"
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.uploadFullProfilePdfAria',
            defaultMessage: 'Upload full profile PDF',
          })}
          aria-modal={true}>
          <FocusLock disabled={!this.props.showPdfModal} returnFocus={true}>
            <Modal
              className="pupup-center pdf-upload-modal"
              isOpen={this.props.showPdfModal}
              onRequestHide={() => this.hidePdfModal('outside')}>
              <ModalBody>
                <UploadPdf id={fetchId} hideModal={this.hidePdfModal} />
              </ModalBody>
            </Modal>
          </FocusLock>
        </div>
        <div
          role="dialog"
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.changeTargetFunctionsAria',
            defaultMessage: 'Change target functions',
          })}
          aria-modal={true}>
          <FocusLock
            disabled={!this.state.showTargetFuncModal}
            returnFocus={true}>
            <Modal
              id="select-target-function"
              isOpen={this.state.showTargetFuncModal}
              onRequestHide={() => this.hideTargetFuncModal('outside')}
              className="sf-modal">
              <ModalBody>
                <ChangeFunction
                  id={fetchId}
                  hideModal={this.hideTargetFuncModal}
                  isChangefunction={true}
                  aspireTracker={aspireTracker}
                />
              </ModalBody>
            </Modal>
          </FocusLock>
        </div>
        <div
          role="dialog"
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.updateLinkedinProfileAria',
            defaultMessage: 'Update changes into your linkedin profile',
          })}
          aria-modal={true}>
          <FocusLock
            disabled={!this.state.showDirectIntegrationModal}
            returnFocus={true}>
            <Modal
              id="linkedin-integration"
              isOpen={this.state.showDirectIntegrationModal}
              onRequestHide={() => this.hideDirectIntegrationModal('outside')}
              className="linkedin-integration-modal">
              <ModalBody>
                <IntegrateToLinkedIn
                  id={fetchId}
                  hideModal={this.hideDirectIntegrationModal}
                  sectionToSuggestCopy={sectionToSuggestCopy.section_array}
                  feedbackData={feedbackData}
                  downloadImage={this.downloadImageDebounce}
                  linkedInUrl={linkedInUrl}
                  community={community}
                  benchmark={benchmark}
                  getTextFromFeedback={this.getTextFromFeedback}
                />
              </ModalBody>
            </Modal>
          </FocusLock>
        </div>
        <div
          role="dialog"
          aria-label={intl.formatMessage({
            id: 'aspire.appBar.customerFeedbackFormAria',
            defaultMessage: 'Customer feedback form',
          })}
          aria-modal={true}>
          <CustomerFeedback />
        </div>
        <LogScreen
          show={this.props.show_log_modal}
          fetchId={fetchId}
          sectionName={'Profile Picture'}
          logs={this.props.ui['logs']}
          feedback={this.props.ui['sections']}
          prevData={this.props.ui.sectionWiseTextStatic}
          showLogModal={this.showLogModal}
          hideLogModal={this.hideLogModal}
        />
        {this.renderAspireIntroVideo()}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    idResume: state.AspireUploadResume.id,
    idPdf: state.uploadPdf.id,
    idFunction: state.changeFunction.id,
    idEdit: state.editData.id,
    uploadedAtEdit: state.editData.uploaded_at,
    uploaded_resume: state.AspireUploadResume.uploaded_resume,
    uploaded_pdf: state.uploadPdf.uploaded_pdf,
    changed_function: state.changeFunction.changed_function,
    uploaded_edited_data: state.editData.uploaded_edited_data,
    feedback_fetching: state.aspireFeedbackData.fetching,
    currentResumeId: state.aspireFeedbackData.resume_id,
    status: state.aspireFeedbackData.status,
    showPdfModal: state.uploadPdf.showPdfModal,
    processingStatus: state.aspireFeedbackData.status,
    allSmallResume: state.aspireFeedbackData.allSmallResume,
    normalResume: state.aspireFeedbackData.normalResume,
    ui: state.detailedFeedbackUi,
    functions: state.aspireFunctionMappings.function_mappings,
    visited_sections: state.aspireFeedbackData.visited_sections,
    customerFeedback: state.customerFeedback,
    sectionToSuggestCopy: state.aspireFeedbackData.sectionToSuggestCopy,
    feedbackData: state.aspireFeedbackData.data.section_wise_feedback,
    linkedInUrl: state.aspireFeedbackData.data.linkedin_url,
    isEditOpen: state.detailedFeedbackUi.isEditOpen,
    hasResume: state.aspireFeedbackData.has_resume,
    lastSaved: state.aspireFeedbackData.lastSaved,
    allResumes: state.resumeHistory.data,
    userCustomizations: state.userCustomizations.data,
    user: state.user.data,
    aspireUploadCount: state.aspireUploadCount.data.uploaded,
    show_log_modal: state.editData.show_log_modal,
    isEditModal: state.editData.show_edit_modal,
    pdfLanguage: state.aspireFeedbackData.pdf_language,
  }
}
export default connect(mapStateToProps, {
  updateResumeState,
  updatePdfState,
  updateFunctionState,
  updateEditedDataState,
  startTour,
  generatePdf,
  checkForRendering,
  showFeedbackModal,
  downloadImage,
  fetchUploadCount,
  uploadResumeInit,
  uploadResumeDone,
  updateResumeFeedback,
  aspireIntroToggle,
  fetchResumeFunc,
  fetchCFFunc,
  getSuggestedFunctions,
  showLogModal,
  selectSection,
  showEditModal,
  redirectSelect,
})(injectIntl(AppBar))

const AspireTracker = (props) => <PageTracking product="aspire" {...props} />
